import { types as coreTypes } from '@sitebuilder/core';

export interface ISettingsApiClient {
    saveSettings(
        settings: coreTypes.Settings,
        options?: { originalHostname?: string; accessToken?: string }
    ): Promise<void>;

    getSettings(options?: {
        originalHostname?: string;
        accessToken?: string;
    }): Promise<coreTypes.Settings>;
}

export class SettingsApiClient implements ISettingsApiClient {
    baseUrl: string;
    constructor(baseUrl: string = '') {
        this.baseUrl = baseUrl;
    }

    private getHeaders(
        h: {
            [key: string]: string;
        },
        options?: { accessToken?: string }
    ) {
        const headers: {
            [key: string]: string;
        } = {};

        if (typeof options?.accessToken === 'string' && options.accessToken.length > 0) {
            headers.Authorization = `bearer ${options.accessToken}`;
        }

        return { ...headers, ...h };
    }

    async saveSettings(
        settings: coreTypes.Settings | {},
        options?: { originalHostname?: string; accessToken?: string }
    ) {
        const url = `${this.baseUrl || ''}/api/admin/settings`;

        const res = await fetch(url, {
            method: 'PUT',
            headers: this.getHeaders(
                {
                    'Content-Type': 'application/json',
                },
                options
            ),
            body: JSON.stringify(settings),
        });

        if (!res.ok) {
            throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        }

        const contentType = res.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
            const updatedSettings = await res.json();
            return updatedSettings;
        }
        
        return {};
    }

    async getSettings(options?: { originalHostname?: string; accessToken?: string }) {
        const url = `${this.baseUrl || ''}/api/admin/settings`;

        const res = await fetch(url, {
            method: 'GET',
            headers: this.getHeaders({}, options),
        });

        if (!res.ok) {
            throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        }

        const settings = await res.json();
        return settings as coreTypes.Settings;
    }
}
